import { ChangeDetectorRef, Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-option-view-component',
  templateUrl: './option-view.component.html',
  styleUrls: ['./option-view.component.css'],
})
export class OptionViewComponent extends BaseComponent implements OnChanges {
  @Input() fields: any = [];
  @Input() addButton: boolean = false;
  @Input() removeButton: boolean = false;
  @Output() onChange = new EventEmitter();
  @Output() onAddClick = new EventEmitter();
  @Output() onRemoveClick = new EventEmitter();
  public displayOption = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {
    this.displayOption = this.fields.map(field => field);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fields && changes.fields.currentValue) {
      this.displayOption = this.fields.map(field => field);
    }
  }
  changedOption(index) {
    this.displayOption[index].display = !this.displayOption[index].display;
    this.onChange.emit({ data: this.displayOption });
  }
  addClick() {
    this.onAddClick.emit();
  }
  removeClick(index) {
    this.onRemoveClick.emit({ item: this.displayOption[index] });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/table-component/option-view/option-view.component.ts